var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-result-company-scan",
      class: _vm.classes,
      attrs: { "data-bot": "search-result__company-scan" },
      on: {
        mouseenter: _vm.handleMouseEnter,
        mouseleave: function($event) {
          _vm.isHovered = false
        }
      }
    },
    [
      _c("CompassObject", {
        attrs: { size: "extra-small", type: "object", object: "company" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "search-result-company-scan__content" }, [
        _c("div", { staticClass: "search-result-company-scan__title" }, [
          _c("h5", {
            staticClass:
              "search-result-company-scan__name typographies-paragraph-medium-bold",
            domProps: { innerHTML: _vm._s(_vm.name) }
          })
        ]),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass:
              "search-result-company-scan__details typographies-paragraph-medium-regular"
          },
          [
            _c("li", [_vm._v(_vm._s(_vm.formatAddress))]),
            _vm._v(" "),
            _vm.siret
              ? _c(
                  "li",
                  { staticClass: "search-result-company-scan__address" },
                  [_vm._v(_vm._s(_vm.siret))]
                )
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("CompassButton", {
        attrs: {
          label: _vm.$t.__("common.actions.add"),
          type: "tertiary",
          leftIcon: "plus"
        },
        on: { click: _vm.handleSelect }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }